import { atomWithStorage } from 'jotai/utils';

export const interestCallbackSent = atomWithStorage<string>("interestCallbackSent", "");
